import React from 'react';
import '../../styles/AdminPages.css';

const Settings = () => {
  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Settings</h1>
        <p>Configure your admin panel settings</p>
      </div>
      
      <div className="admin-card">
        <h3 style={{ marginBottom: '1.5rem' }}>General Settings</h3>
        <div className="admin-form">
          <div className="admin-form-group">
            <label>Site Name</label>
            <input type="text" defaultValue="BookMyCamera" />
          </div>
          <div className="admin-form-group">
            <label>Contact Email</label>
            <input type="email" defaultValue="admin@bookmycamera.com" />
          </div>
          <button className="admin-button primary">Save Changes</button>
        </div>
      </div>
    </div>
  );
};

export default Settings;

